import React from 'react';
import { VideoPlayer } from '_ui-core-js/React/components/VideoPlayer.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { AnimatedTextHeader } from '_ui-core-js/React/components/AnimatedTextHeader.jsx';
import { object, string } from 'prop-types';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function VideoBanner(props) {

  const { video, title, subtitle, settings } = props;
  const block = 'c-video-banner';

  return (
    <section id="film" className={`${block} utils__section-padding-small--bottom`} role='region' >
      <header className={`${block}__header`}>
        <div className={`${block}__format-heading`}>
          <span className={`${block}__range-title`}>
            {subtitle.split('').map((letter, index) => (
              <CssAnimation
                enter={{
                  name: 'fade-in',
                  delay: `${index * 0.5}, hidden`,
                  duration: 0.5
                }}
                triggerEnter={'in-view-init'}
                key={letter}
              >
                <span className={`${block}__range-letters`} key={index}>
                  {letter}
                </span>
              </CssAnimation>
            ))}
          </span>
          <div className={`${block}__title`}>
            <AnimatedTextHeader
              heading={title}
              headingClasses={`${block}__heading`}
            />
          </div>
        </div>
      </header>
      <CssAnimation
        enter={{
          name: 'vertical-top-bottom-clip',
          delay: `0.5, hidden`,
          duration: 1,
          easing: 'ease-out'
        }}
        triggerEnter={'in-view-init'}
      >
        <div className={`${block}__video-container`}>
          <VideoPlayer
            src={video.url}
            poster={video.poster}
            fullscreen={true}
            assetRootPath={`${settings.assetRootPath}/assets/images/`}
            gtmComponentName={LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceExtraordinaryVideo}
            gtmComponentGroup={CORE_GTM_TRACKING_VALUES.componentGroup.newCars}
          />
        </div>
      </CssAnimation>
    </section>
  );
};

VideoBanner.propTypes = {
  video: object.isRequired,
  title: string,
  subtitle: string,
  settings: object
};